import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const CollapsibleSection = ({ title, children, onToggle, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="mb-2 border border-gray-200 dark:border-gray-500 rounded overflow-hidden">
      <div
        className="flex justify-between items-center bg-gray-200 dark:bg-gray-600 p-2 cursor-pointer select-none"
        onClick={() => {onToggle(!isOpen); setIsOpen(!isOpen)}}
      >
        <h3 className="text-gray-900 dark:text-gray-200 text-lg font-semibold">{title}</h3>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      {isOpen && <div className="p-4">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;